import React from "react";
import "../App.css";

import CardAik_5 from "../assets/fighting_styles/webp/CardAik_5.webp";
import CardAik_5_05 from "../assets/fighting_styles/webp_05x/CardAik_5@0.5x.webp";

import CardBoxing_3 from "../assets/fighting_styles/webp/CardBoxing_3.webp";
import CardBoxing_3_05 from "../assets/fighting_styles/webp_05x/CardBoxing_3@0.5x.webp";

import CardJiuJitsu_8 from "../assets/fighting_styles/webp/CardJiuJitsu_8.webp";
import CardJiuJitsu_8_05 from "../assets/fighting_styles/webp_05x/CardJiuJitsu_8@0.5x.webp";

import CardKarate_1 from "../assets/fighting_styles/webp/CardKarate_1.webp";
import CardKarate_1_05 from "../assets/fighting_styles/webp_05x/CardKarate_1@0.5x.webp";

import CardKickBoxing_2 from "../assets/fighting_styles/webp/CardKickBoxing_2.webp";
import CardKickBoxing_2_05 from "../assets/fighting_styles/webp_05x/CardKickBoxing_2@0.5x.webp";

import CardKravMaga_4 from "../assets/fighting_styles/webp/CardKravMaga_4.webp";
import CardKravMaga_4_05 from "../assets/fighting_styles/webp_05x/CardKravMaga_4@0.5x.webp";

import CardKudo_4 from "../assets/fighting_styles/webp/CardKudo_4.webp";
import CardKudo_4_05 from "../assets/fighting_styles/webp_05x/CardKudo_4@0.5x.webp";

import CardMuay_2 from "../assets/fighting_styles/webp/CardMuay_2.webp";
import CardMuay_2_05 from "../assets/fighting_styles/webp_05x/CardMuay_2@0.5x.webp";

import CardSambo_5 from "../assets/fighting_styles/webp/CardSambo_5.webp";
import CardSambo_5_05 from "../assets/fighting_styles/webp_05x/CardSambo_5@0.5x.webp";

import CardShaolin_1 from "../assets/fighting_styles/webp/CardShaolin_1.webp";
import CardShaolin_1_05 from "../assets/fighting_styles/webp_05x/CardShaolin_1@0.5x.webp";

import CardWrestling_6 from "../assets/fighting_styles/webp/CardWrestling_6.webp";
import CardWrestling_6_05 from "../assets/fighting_styles/webp_05x/CardWrestling_6@0.5x.webp";

import WingChunCard from "../assets/fighting_styles/webp/CardWingChun_1.webp";
import WingChunCard_05 from "../assets/fighting_styles/webp_05x/CardWingChun_1@0.5x.webp";

const styles = [
    { name: "Karate", img: CardKarate_1, img05: CardKarate_1_05, text: "Text about style" },
    { name: "Aikido", img: CardAik_5, img05: CardAik_5_05, text: "Text about style" },
    { name: "Kickboxing", img: CardKickBoxing_2, img05: CardKickBoxing_2_05, text: "Text about style" },
    { name: "Sambo", img: CardSambo_5, img05: CardSambo_5_05, text: "Text about style" },
    { name: "Kudo", img: CardKudo_4, img05: CardKudo_4_05, text: "Text about style" },
    { name: "Boxing", img: CardBoxing_3, img05: CardBoxing_3_05, text: "Text about style" },
    { name: "Wing Chun", img: WingChunCard, img05: WingChunCard_05, text: "Text about style" },
    { name: "Brazilian Jiu Jitsu", img: CardJiuJitsu_8, img05: CardJiuJitsu_8_05, text: "Text about style" },
    { name: "Muay Thai", img: CardMuay_2, img05: CardMuay_2_05, text: "Text about style" },
    { name: "Shaolin", img: CardShaolin_1, img05: CardShaolin_1_05, text: "Text about style" },
    { name: "Krav Maga", img: CardKravMaga_4, img05: CardKravMaga_4_05, text: "Text about style" },
    { name: "Wrestling", img: CardWrestling_6, img05: CardWrestling_6_05, text: "Text about style" },
];

const FightingStyles = ({ t }) => {
    const copy = t.fightingStyles;

    return (
        <div className="i fightstyles-page">
            <div className="styles-head">
                <h1>{copy.title}</h1>
            </div>

            <ul className="styles-list">
                {styles.map((s) => (
                    <li key={s.name}>
                        <img
                            src={s.img05}
                            srcSet={`${s.img05} 460w, ${s.img} 921w`}
                            sizes="(max-width: 768px) 78vw, (max-width: 1100px) 33vw, 16vw"
                            alt={copy.names[s.name] || s.name}
                            loading="lazy"
                            decoding="async"
                        />
                        <div className="effect-to-top">
                            <h3>{copy.names[s.name] || s.name}</h3>
                            <p>{copy.text}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default FightingStyles;
